import { Box, Heading, Text } from '@chakra-ui/react';
import React from 'react';
import { useTokens } from '../../../context/TokenProvider';
const PanelContainerWithFallback = ({ condition, fallbackText, children, title, ...rest }) => {
    const tokens = useTokens();
    const headingStyle = {
        fontSize: tokens.FontSize2,
        lineHeight: tokens.LineHeights6,
        mr: '5px',
        w: '60px',
    };
    const renderInner = () => {
        if (condition === false && fallbackText != null) {
            return (React.createElement(Text, { "data-testid": "fallback_text", variant: "md-600-rg-4" }, fallbackText));
        }
        return children;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { as: "h4", sx: headingStyle, variant: "dk-800-md-6", "data-testid": "panel__header" }, title),
        React.createElement(Box, { ...rest }, renderInner())));
};
export default PanelContainerWithFallback;
